<template lang="pug">
  v-data-table.ma-4(
    :headers="headers"
    :items="requests"
    class="task-table"
    hide-default-footer
    disable-pagination
  )
    template(v-slot:item.id="{ item }")
      span {{ item.id }}
    template(v-slot:item.chat_room_id="{ item }")
      v-btn.ml-n4(
        :to=`{
          name: 'ExchangeRequests',
        }`
        color="info"
        text
        rounded
      ) Ответить в чате

</template>

<script>
export default {
  name: 'CourseRequestsTable',
  props: {
    /**
     * Заявки для курса
     */
    requests: {
      type: Array,
      default: () => ([]),
    },
  },
  data: () => ({
    headers: [
      { text: 'ID заявки', value: 'id' },
      { text: 'Ссылка на чат', value: 'chat_room_id' },
    ],
  }),
};
</script>

<style lang="scss" scoped>

</style>
